import {
  CLOSE_FACEBOOK_ACCOUNT_ALREADY_LINKED_POPUP,
  CLOSE_FACEBOOK_LOGIN_NOT_POSSIBLE_ERROR_POPUP,
  OPEN_FACEBOOK_ACCOUNT_ALREADY_LINKED_POPUP,
  OPEN_FACEBOOK_LOGIN_NOT_POSSIBLE_ERROR_POPUP,
  SET_FACEBOOK,
} from '../actions/accountDetails/facebookSettings';
import {
  CLOSE_PAYPAL_ACCOUNT_ALREADY_LINKED_POPUP,
  CLOSE_PAYPAL_LOGIN_NOT_POSSIBLE_ERROR_POPUP,
  OPEN_PAYPAL_ACCOUNT_ALREADY_LINKED_POPUP,
  OPEN_PAYPAL_LOGIN_NOT_POSSIBLE_ERROR_POPUP,
  SET_PAYPAL,
} from '../actions/accountDetails/paypalSettings';
import {
  CONTACT_DETAILS_VALIDATION_ERRORS,
  SET_CONTACT_DETAILS,
} from '../actions/accountDetails/contactDetails';
import {
  SET_CHANGE_EMAIL_VALIDATION_ERRORS,
  SET_CHANGE_PASSWORD_VALIDATION_ERRORS,
} from '../actions/accountDetails/changeCredentials';
import {
  SET_PAYMENT_DETAILS,
  SET_PAYMENT_METHOD_ERROR,
} from '../actions/accountDetails/storedPaymentDetails';
import {
  LINK_USAGE_INIT,
  LINK_USAGE_INIT_ERROR,
  LINK_USAGE_INIT_REDIRECT,
  LINK_USAGE_FINISH_PAYMENT,
  LINK_USAGE_REINIT_PAYMENT,
  LINK_USAGE_SET_INITIAL_STATE,
} from '../actions/accountDetails/paymentUsage';
import { SET_AVAILABLE_LOGIN_METHODS } from 'apps/login/actions/loginElevated';
import {
  closeFacebookAccountAlreadyLinkedPopup,
  closeFacebookLoginNotPossibleErrorPopup,
  openFacebookAccountAlreadyLinkedPopup,
  openFacebookLoginNotPossibleErrorPopup,
  setFacebook,
} from './accountDetails/settingsFacebookActions';
import {
  closePayPalAccountAlreadyLinkedPopup,
  closePayPalLoginNotPossibleErrorPopup,
  openPayPalAccountAlreadyLinkedPopup,
  openPayPalLoginNotPossibleErrorPopup,
  setPayPal,
} from './accountDetails/settingsPaypalActions';
import {
  finishLinkUsagePayment,
  initLinkUsage,
  initLinkUsageRedirect,
  initLinkUsageError,
  reinitLinkUsagePayment,
  setLinkUsageInitialState,
  setPaymentDetails,
  setPaymentMethodError,
} from './accountDetails/settingsPaymentActions';
import {
  contactDetailsValidationErrors,
  setContactDetails,
} from './accountDetails/settingsContactDetailsActions';

export const settingsAccountDetailsActions = {
  /* Payment Details */
  [SET_PAYMENT_DETAILS]: setPaymentDetails,
  [SET_PAYMENT_METHOD_ERROR]: setPaymentMethodError,
  [LINK_USAGE_INIT]: initLinkUsage,
  [LINK_USAGE_INIT_REDIRECT]: initLinkUsageRedirect,
  [LINK_USAGE_INIT_ERROR]: initLinkUsageError,
  [LINK_USAGE_REINIT_PAYMENT]: reinitLinkUsagePayment,
  [LINK_USAGE_FINISH_PAYMENT]: finishLinkUsagePayment,
  [LINK_USAGE_SET_INITIAL_STATE]: setLinkUsageInitialState,
  /* Contact Details */
  [SET_CONTACT_DETAILS]: setContactDetails,
  [CONTACT_DETAILS_VALIDATION_ERRORS]: contactDetailsValidationErrors,
  /* Login & Password */
  [SET_AVAILABLE_LOGIN_METHODS]: ({ state, action }) => ({ ...state, hasPassword: action.hasPassword }),
  [SET_CHANGE_EMAIL_VALIDATION_ERRORS]: ({ state, action }) => ({
    ...state,
    changeEmailValidationErrors: action.errors,
  }),
  [SET_CHANGE_PASSWORD_VALIDATION_ERRORS]: ({ state, action }) => ({
    ...state,
    changePasswordValidationErrors: action.errors,
  }),
  /* Facebook Login */
  [SET_FACEBOOK]: setFacebook,
  [OPEN_FACEBOOK_ACCOUNT_ALREADY_LINKED_POPUP]: openFacebookAccountAlreadyLinkedPopup,
  [CLOSE_FACEBOOK_ACCOUNT_ALREADY_LINKED_POPUP]: closeFacebookAccountAlreadyLinkedPopup,
  [OPEN_FACEBOOK_LOGIN_NOT_POSSIBLE_ERROR_POPUP]: openFacebookLoginNotPossibleErrorPopup,
  [CLOSE_FACEBOOK_LOGIN_NOT_POSSIBLE_ERROR_POPUP]: closeFacebookLoginNotPossibleErrorPopup,
  /* PayPal Login */
  [SET_PAYPAL]: setPayPal,
  [OPEN_PAYPAL_ACCOUNT_ALREADY_LINKED_POPUP]: openPayPalAccountAlreadyLinkedPopup,
  [CLOSE_PAYPAL_ACCOUNT_ALREADY_LINKED_POPUP]: closePayPalAccountAlreadyLinkedPopup,
  [OPEN_PAYPAL_LOGIN_NOT_POSSIBLE_ERROR_POPUP]: openPayPalLoginNotPossibleErrorPopup,
  [CLOSE_PAYPAL_LOGIN_NOT_POSSIBLE_ERROR_POPUP]: closePayPalLoginNotPossibleErrorPopup,
};
